import { Popover } from "@mui/material";
import type { ReactI18NextChild } from "react-i18next";

import styles from "./style.module.scss";

/**
 * Render a styled popover
 */
interface IStyledPopover {
    open: boolean;
    onClose: () => void;
    anchorEl: any;
    children: ReactI18NextChild;
    multicolor?: boolean;
}

const StyledPopover = ({ open, onClose, anchorEl, children, multicolor = false }: IStyledPopover) => {
    return (
        <Popover
            className={multicolor ? styles["multicolor-popover"] : ""}
            open={open}
            elevation={0}
            anchorEl={anchorEl}
            onClose={onClose}
            sx={{ zIndex: 2000 }} // z-index over mui-tooltip
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
        >
            <div className={multicolor ? styles["multicolor-popover-list-container"] : ""}>{children}</div>
        </Popover>
    );
};

export default StyledPopover;
